import { IQuestion } from '../common/interfaces/Question.interface';
import { IOption } from '../common/interfaces/Option.interface';
import { getLocalizedValueFromMultiLangValues } from './getLocalizedValueFromMultiLangValues';

export const getCorrectAnswerForQuestion = (question: IQuestion) => {
  const correctOption = question.answers?.[0]?.dataSources?.[0].options?.find(
    (option: IOption) => option.isCorrect === true
  );

  return correctOption
    ? getLocalizedValueFromMultiLangValues(correctOption.value)
    : undefined;
};
